'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var currencyCode = exports.currencyCode = function currencyCode() {
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UK';

  switch (country.toLowerCase()) {
    case 'au':
      return 'AUD';
    case 'us':
      return 'USD';
    case 'ie':
      return 'EUR';
    case 'sg':
      return 'SGD';
    case 'hk':
      return 'HKD';
    case 'ca':
      return 'CAD';
    case 'za':
      return 'ZAR';
    default:
      return 'GBP';
  }
};

var currencySymbol = exports.currencySymbol = function currencySymbol() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GBP';

  switch (code.toLowerCase()) {
    case 'gbp':
      return '£';
    case 'hkd':
      return 'HK$';
    case 'aed':
      return 'د.إ';
    default:
      return '$';
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/currencies/index.js
// module id = 622
// module chunks = 0